// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseIcon_root__10yFr"};